import React, { useEffect, useState } from 'react';
import './content.css';
import Nav from '../components/layout/nav';
import { supabase } from '../supabase';

const Content = () => {
  const [tickets, setTickets] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);

  const [saving, setSaving] = useState(false);

  const [editingTicket, setEditingTicket] = useState(null);
  const [ticketForm, setTicketForm] = useState({
    title: '',
    description: '',
    price: '',
    type: ''
  });
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [scheduleForm, setScheduleForm] = useState({
    designer: '',
    collection: '',
    date: '',
    time: '',
    day: '',
    location: ''
  });

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);

    const { data: t, error: te } = await supabase
      .from('tickets')
      .select('*')
      .order('id');

    const { data: s, error: se } = await supabase
      .from('schedule')
      .select('*')
      .order('id');

    if (te) console.error('Tickets error:', te);
    if (se) console.error('Schedule error:', se);

    setTickets(t || []);
    setSchedule(s || []);
    setLoading(false);
  };
  const startTicketEdit = (t) => {
    setEditingTicket(t.id);
    setTicketForm({
      title: t.title || '',
      description: t.description || '',
      price: t.price || '',
      type: t.type || ''
    });
  };

  const saveTicket = async (id) => {
    setSaving(true);

    const { error } = await supabase
      .from('tickets')
      .update(ticketForm)
      .eq('id', id);

    setSaving(false);

    if (error) {
      alert(error.message);
      return;
    }

    setEditingTicket(null);
    setTicketForm({
      title: '',
      description: '',
      price: '',
      type: ''
    });

    setTickets(prev =>
      prev.map(t => (t.id === id ? { ...t, ...ticketForm } : t))
    );
  };

  const deleteTicket = async (id) => {
    const ok = window.confirm('Delete this ticket?');
    if (!ok) return;

    const { error } = await supabase
      .from('tickets')
      .delete()
      .eq('id', id);

    if (error) {
      alert(error.message);
      return;
    }

    setTickets(prev => prev.filter(t => t.id !== id));
  };

  const startScheduleEdit = (item) => {
    setEditingSchedule(item.id);
    setScheduleForm({
      designer: item.designer || '',
      collection: item.collection || '',
      date: item.date || '',
      time: item.time || '',
      day: item.day || '',
      location: item.location || ''
    });
  };

  const saveSchedule = async (id) => {
    setSaving(true);

    const { error } = await supabase
      .from('schedule')
      .update(scheduleForm)
      .eq('id', id);

    setSaving(false);

    if (error) {
      alert(error.message);
      return;
    }

    setEditingSchedule(null);
    setScheduleForm({
      designer: '',
      collection: '',
      date: '',
      time: '',
      day: '',
      location: ''
    });

    setSchedule(prev =>
      prev.map(s => (s.id === id ? { ...s, ...scheduleForm } : s))
    );
  };

  const deleteSchedule = async (id) => {
    const ok = window.confirm('Delete this schedule item?');
    if (!ok) return;

    const { error } = await supabase
      .from('schedule')
      .delete()
      .eq('id', id);

    if (error) {
      alert(error.message);
      return;
    }

    setSchedule(prev => prev.filter(s => s.id !== id));
  };

  return (
    <div className="dashboard">
      <Nav />

      <div className="mainarea">
         <div className='navtoppart'>

                    <div className='welcomebcakdiv'>
                        <h6 className='welcomebacktext'>Welcome back</h6>
                        <h6 className='admintitle'>Admin Dashboard</h6>
                    </div>

                    <div className='profileandnotidiv'>
                        <div className='notidiv'>
                            <div className='notiicon'></div>
                        </div>
                        <div className='profilediv'></div>
                    </div>

                </div>
        <div className="pagecenter">
          <div className="homecontainer">

            <div className='titlediv2'>
                                     <div className='titlediv'>
                                            <h1>Content</h1>
                                            <h2>Manage App and Website Content</h2>
                                        </div>
                                    
                            </div>

            {loading && <p className="content-loading">Loading...</p>}
            <h2 className="contentsectiontitle">Tickets</h2>

            <div className="admingrid">
              {tickets.map((t) => (
                <div key={t.id} className="admincard">

                  {editingTicket === t.id ? (
                    <div className="adminform">

                      <input
                        value={ticketForm.title}
                        onChange={(e) =>
                          setTicketForm({ ...ticketForm, title: e.target.value })
                        }
                      />

                      <textarea
                        value={ticketForm.description}
                        onChange={(e) =>
                          setTicketForm({ ...ticketForm, description: e.target.value })
                        }
                      />

                      <input
                        value={ticketForm.price}
                        onChange={(e) =>
                          setTicketForm({ ...ticketForm, price: e.target.value })
                        }
                      />

                      <input
                        value={ticketForm.type}
                        onChange={(e) =>
                          setTicketForm({ ...ticketForm, type: e.target.value })
                        }
                      />

                      <div className="adminactions">
                        <button onClick={() => saveTicket(t.id)} disabled={saving}>
                          {saving ? 'Saving...' : 'Save'}
                        </button>

                        <button onClick={() => setEditingTicket(null)}>
                          Cancel
                        </button>
                      </div>

                    </div>
                  ) : (
                    <div className="adminvv">
                      <h3 className='showwwtitle'>{t.title}</h3>
                      <p className='contentdess'>{t.description}</p>
                      <span className='contentprice'>{t.price}</span>

                      <div className='buttonalignn'>
                        <button className='editbtt' onClick={() => startTicketEdit(t)}>Edit</button>
                        <button   className=' viewdetalsbtn deltee'onClick={() => deleteTicket(t.id)}>Delete</button>
             
                      </div>
                    </div>
                  )}

                </div>
              ))}
            </div>

            <h2 className="contentsectiontitle">Schedule</h2>

            <div className="admingrid">
              {schedule.map((item) => (
                <div key={item.id} className="admincard">

                  {editingSchedule === item.id ? (
                    <div className="adminform">

                      <input
                        value={scheduleForm.designer}
                        onChange={(e) =>
                          setScheduleForm({ ...scheduleForm, designer: e.target.value })
                        }
                      />

                      <input
                        value={scheduleForm.collection}
                        onChange={(e) =>
                          setScheduleForm({ ...scheduleForm, collection: e.target.value })
                        }
                      />

                      <input
                        value={scheduleForm.date}
                        onChange={(e) =>
                          setScheduleForm({ ...scheduleForm, date: e.target.value })
                        }
                      />

                      <input
                        value={scheduleForm.time}
                        onChange={(e) =>
                          setScheduleForm({ ...scheduleForm, time: e.target.value })
                        }
                      />

                      <input
                        value={scheduleForm.day}
                        onChange={(e) =>
                          setScheduleForm({ ...scheduleForm, day: e.target.value })
                        }
                      />

                      <input
                        value={scheduleForm.location}
                        onChange={(e) =>
                          setScheduleForm({ ...scheduleForm, location: e.target.value })
                        }
                      />

                      <div className="adminactions">
                        <button onClick={() => saveSchedule(item.id)} disabled={saving}>
                          {saving ? 'Saving...' : 'Save'}
                        </button>

                        <button onClick={() => setEditingSchedule(null)}>
                          Cancel
                        </button>
                      </div>

                    </div>
                  ) : (
                    <div className="adminvv">

                      <h3 className='showwwtitle'>{item.designer}</h3>
                      <p className='contentdess'>{item.collection}</p>

                      <div className="adminm">
                        <span className='contentprice'>{item.date}</span>
                        <span className='contentprice'>{item.time}</span>
                        <span className='contentprice'>{item.day}</span>
                        <span className='contentprice'>{item.location}</span>
                      </div>

                      <div className="buttonalignn">
                        <button className='editbtt' onClick={() => startScheduleEdit(item)}>Edit</button>
                        <button className=' viewdetalsbtn deltee' onClick={() => deleteSchedule(item.id)}>Delete</button>
                      </div>

                    </div>
                  )}

                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;